import {
  queryImageList1
} from '../../api/index.js'
export default {
  name: 'detail',
  data () {
    return {
      active: 0,
      imgList: [],
      url: '',
      title: ''
    }
  },
  created () {
    this.getImageList()
  },
  methods: {
    async getImageList () {
      const type = Number(this.$route.query.type)
      const result = await queryImageList1({
        typeLevel1: type === 31 || type === 5 || type === 49 ? 3 : 2,
        typeId: type !== 31 && type !== 5 && type !== 49 ? type : null,
        courseType: type !== 31 && type !== 5 && type !== 49 ? null : type === 5 ? 38 : type
      })
      if (type === 7) {
        this.title = '金融商科'
      } else if (type === 11) {
        this.title = '理工科'
      } else if (type === 13) {
        this.title = '计算机和人工智能'
      } else if (type === 17) {
        this.title = '人文社科'
      } else if (type === 5) {
        this.title = '2024Winter & Summer Onsite Programs'
      } else if (type === 49) {
        this.title = '专业选修课'
      } else {
        this.title = '竞赛'
      }
      this.imgList = result.data
      this.url = this.imgList[this.active].url
    },
    clickImg () {
      this.active = this.active += 1
      this.url = this.imgList[this.active].url
    },
    clickImg1 () {
      this.active = this.active -= 1
      this.url = this.imgList[this.active].url
    },
    savePicture (Url) {
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        const a = document.createElement('a')
        a.href = dataURL
        a.download = name
        document.body.appendChild(a)
        a.click()
        setTimeout(() => {
          document.body.removeChild(a)
          canvas = null
        }, 1000)
      }
      img.src = Url
    }
  }
}
